import React from "react";
import { H2, H3, H4 } from "@ui/IconV2/react";
import type { BlockHeadingImportT } from "../../../../../../schema/block/heading";
import { colors } from "@ui/Theme";
import t from "../../../../../../../../../i18n";

export const Level2HeadingTemplate = {
  icon: () => <H2 size="l" color={colors.carbon800} />,
  title: t("project.dashboard.block.template.heading.title"),
  description: null,
  block: {
    kind: "HEADING",
    data: "",
    config: {
      level: 2,
    },
  } as Omit<BlockHeadingImportT, "dashboardId" | "position">,
};

export const Level3HeadingTemplate = {
  icon: () => <H3 size="l" color={colors.carbon800} />,
  title: t("project.dashboard.block.template.heading.subtitle"),
  description: null,
  block: {
    kind: "HEADING",
    data: "",
    config: {
      level: 3,
    },
  } as Omit<BlockHeadingImportT, "dashboardId" | "position">,
};

export const Level4HeadingTemplate = {
  icon: () => <H4 size="l" color={colors.carbon800} />,
  title: t("project.dashboard.block.template.heading.sub_subtitle"),
  description: null,
  block: {
    kind: "HEADING",
    data: "",
    config: {
      level: 4,
    },
  } as Omit<BlockHeadingImportT, "dashboardId" | "position">,
};

// export const icon = () => <Heading size="l" color={colors.carbon800} />;

// export const title = t("project.dashboard.block.template.heading.title");

// export const description = null;

// export const block: Omit<BlockHeadingImportT, "dashboardId" | "position"> = {
//   kind: "HEADING",
//   data: "",
//   config: {
//     level: 2,
//   },
// };
